// Utility function to render text with HTML bold tags
export const renderTextWithBold = (text: string) => {
    if (!text || typeof text !== "string") return text;
  
    // Split text by <b> and </b> tags
    const parts = text.split(/(<b>.*?<\/b>)/g);
  
    // Add null check for parts array
    if (!parts || !Array.isArray(parts)) return text;
  
    return parts.map((part, index) => {
      if (part.startsWith("<b>") && part.endsWith("</b>")) {
        // Extract content between <b> tags and render as bold
        const boldContent = part.slice(3, -4);
        return (
          <b key={index} className="font-semibold">
            {boldContent}
          </b>
        );
      }
      return part;
    });
  };